<style src="../css/index_community.css">
</style>

<template>
  <div>
    <Head-section></Head-section>
    <div class="container">
      <b-carousel id="carousel-fade" fade controls>
        <a v-for="(prd) in navs" :key="prd"
          :href="prd.redirecturl.replace('http://bluedio.com/'+lan+'/product/','/product/')">
          <b-carousel-slide>
            <img slot="img" class="d-block img-fluid w-100" :src="prd.image" :alt="prd.description">
          </b-carousel-slide>
        </a>
      </b-carousel>
    </div>
    <div class="container">
      <div class="text-white bg-dark pb-1">
        <div class="text-center font-weight-bold p-1">
          <a class="text-white" href="#" @click="toArticles()">{{$t("message.Bluedio_News")}}</a>
        </div>
        <div class="row text-center">
          <div class="col text-center font-weight-bold p-1">
            <p class="text-white">{{$t("message.Recruit")}}</p>
          </div>
          <div class="col text-center font-weight-bold p-1">
            <a class="text-white" href="#" @click="toCustomize()">{{$t("message.Customize")}}</a>
          </div>
          <div class="col text-center font-weight-bold p-1">
            <p class="text-white">{{$t("message.Promotions")}}</p>
          </div>
        </div>

        <div class="row text-center">
          <div class="col text-center font-weight-bold p-1">
            <a class="text-white" href="#" @click="toVideo()">{{$t("message.Video")}}</a>
          </div>
          <div class="col text-center font-weight-bold p-1">
            <a class="text-white" href="#" @click="toForum()">{{$t("message.Forum")}}</a>
          </div>
          <div class="col text-center font-weight-bold p-1">
            <a class="text-white" href="http://code.fangwei315.com/">{{$t("message.Security")}}</a>
          </div>
          <div class="col text-center font-weight-bold p-1">
            <a class="text-white text-justify" href="#" @click="toManual()">{{$t("message.Manual")}}</a>
          </div>
        </div>
      </div>

      <div class="container mt-3">
        <b-card v-for="comm in comms" :key="comm" :title="comm.title" :img-src="comm.cover" img-alt="Image" img-top
          tag="article" class="mb-2" @click="toArtic(comm.id)">
          <b-card-text>
            <div>
              <i class="fas fa-calculator"></i>
              {{comm.createat | time}}
            </div>
            <p class="text-truncate">{{comm.content}}}</p>
          </b-card-text>

          <b-button href="#" variant="btn btn-outline-dark">{{ $t("message.Read_more") }}</b-button>
        </b-card>
      </div>
    </div>
    <div class="d-flex justify-content-center mb-3">
      <b-spinner label="Loading..." variant="success" :class="{'d-none':spin_run}"></b-spinner>
    </div>
    <Foot-section></Foot-section>
  </div>
</template>

<script>
  import HeadSection from "./HeadCommSection.vue";
  import FootSection from "./FootSection.vue";
  import {
    mapActions,
    mapGetters
  } from "vuex";
  export default {
    name: "Community",
    components: {
      HeadSection,
      FootSection
    },
    data() {
      return {
        navs: [],
        comms: [],
        spin_run: false,
        info: null
      };
    },
    computed: mapGetters(["lan"]),

    watch: {
      lan(oldlan, newlan) {
        this.getPrdsCommu();
      }
    },

    mounted() {
      this.getPrdsCommu();

      // axios.get("/api/info/nav/list?location=en&platform=user").then(data => {
      //   this.info = data.data;
      //   if (data.data.result) {
      //     this.navs = data.data.navs;
      //     this.topPrds = data.data.star1;
      //     this.adPrds = data.data.star2;
      //     this.prds = data.data.star3;
      //   }
      // });
    },
    methods: {
      ...mapActions({
        getPrdsCommu(dispatch) {
          this.spin_run = false;
          dispatch("getPrdsCommu", {}).then(data => {
            this.info = data;
            this.spin_run = data.result;
            if (data.result) {
              this.navs = data.navs;
              this.comms = data.comms;
            }
          });
        }
      }),
      toProDet(id) {
        this.$router.replace({
          name: "enProduct",
          params: {
            proid: id
          }
        });
      },
      toArtic(id) {
        this.$router.push({
          name: "enArticle",
          params: {
            articleid: id
          }
        });
      },
      toArticles() {
        this.$router.push({
          name: "enArticleLs"
        });
      },
      toVideo() {
        this.$router.push({
          name: "enVideo"
        });
      },
      toForum() {
        this.$router.push({
          name: "enForum"
        });
      },
      toManual() {
        this.$router.push({
          name: "enManual"
        });
      },
      toCustomize() {
        this.$router.push({
          name: "enCustomize"
        });
      }
    }
  };
</script>